export default {
  header: {
    title: 'Super! Du erhältst Folgendes kostenlos zu deiner Bestellung:',
    subtitle: 'Wir wenden den Rabatt während des Checkout-Prozesses an.',
  },
  footer: {
    buttons: {
      no_thanks: 'Nein, danke',
      add_to_basket: 'Zum Warenkorb hinzufügen',
    },
  },
};
